import { render } from "./TagResume.vue?vue&type=template&id=ad3eca82"
import script from "./TagResume.vue?vue&type=script&lang=js"
export * from "./TagResume.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__